import request from "@/utils/request";

export function getTemplateFileUrl() {
  return request({
    url: "/test/reportConclusive/getTemplateFileUrl",
    method: "get",
  });
}

export function selectPageList(data) {
  return request({
    url: "/test/reportConclusive/selectPageList",
    method: "post",
    data: data,
  });
}
export function insertOne(data) {
  return request({
    url: "/test/reportConclusive/insertOne",
    method: "post",
    data: data,
  });
}
export function detailData(data) {
    return request({
      url: "/test/reportConclusive/detail",
      method: "post",
      data: data,
    });
  }

  export function deleteBatch(data) {
    return request({
      url: "/test/reportConclusive/deleteBatch",
      method: "post",
      data: data,
    });
  }
  
